module.exports = __webpack_public_path__ + "static/media/space-background.4675f42e.png";